<template>
  <div>
    <a-card :bordered="true" >
      <span slot="title">
        {{ title }}
        <span style="color: red;font-size: 13px">{{ subTitle === '' ? '': '：('+subTitle+')' }}</span>
      </span>
      <a-table
        :bordered="false"
        :dataSource="dataSource"
        :columns="columns"
        :pagination="false"
        :scroll="isScroll?{ x: '150%' }: { x: '100%' }"
      >
        <template slot="name" slot-scope="text, record">
          <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
        </template>
        <template slot="operation" slot-scope="text, record" >
          <a
            @click="() => editChild(record)"
            v-show="String(childType) !== 'show'"
          >修改</a>
          <a-divider type="vertical" v-show="String(childType) !== 'show'"/>
          <a-popconfirm
            v-if="dataSource.length"
            title="确定删除这条吗"
            @confirm="() => onDelete(record)"
          >
            <a href="javascript:;" v-show="String(childType) !== 'show'">删除</a>
          </a-popconfirm>
        </template>

      </a-table>
      <a-button type="dashed" style="width: 100%" :disabled="showable" @click="add" v-if="title === '进场固定资产'">
        <a-icon
          type="plus"
        /> 新购
      </a-button>
      <a-button type="dashed" style="width: 100%" :disabled="showable" @click="add" v-if="title != '进场固定资产'">
        <a-icon
          type="plus"
        /> 添加
      </a-button>
    </a-card>
    <!--    以下是调用各种添加弹框-->
    <daily-work-add
      :project-id="projectId"
      @changeData="changeData"
      @editData="editData"
      ref="dailyWorkAdd"
    />
    <daily-hire-work-add
      @changeData="changeData"
      @editData="editData"
      ref="dailyHireWorkAdd"
    />
    <daily-out-machine-add
      @changeData="changeData"
      @editData="editData"
      @changeDelete="changeDelete"
      ref="dailyOutMachineAdd"
    />
    <daily-tree-add
      @changeData="changeData"
      @editData="editData"
      ref="dailyTreeAdd"
    />
    <daily-material-add
      @changeData="changeData"
      @editData="editData"
      ref="dailyMaterialAdd"
    />
    <daily-asset-add
      @changeData="changeData"
      @editData="editData"
      ref="dailyAssetAdd"
    />
    <daily-other-cost-add
      @changeData="changeData"
      @editData="editData"
      ref="dailyOtherCostAdd"
    />
  </div>
</template>

<script>
import dailyWorkAdd from './dailyWorkAdd'
import dailyOutMachineAdd from './dailyOutMachineAdd'
import dailyAssetAdd from './dailyAssetAdd'
import dailyTreeAdd from './dailyTreeAdd'
import dailyMaterialAdd from './dailyMaterialAdd'
import dailyOtherCostAdd from './dailyOtherCostAdd'
import dailyHireWorkAdd from './dailyHireWorkAdd'
export default {
  name: 'DailyComponent',
  components: {
    dailyWorkAdd,
    dailyHireWorkAdd,
    dailyOutMachineAdd,
    dailyAssetAdd,
    dailyMaterialAdd,
    dailyTreeAdd,
    dailyOtherCostAdd
  },
  props: {
    title: {
      type: String,
      default: '标题'
    },
    // 副标题，小标题后面哪个东西
    subTitle: {
      type: String,
      default: ''
    },
    // 获取是查看、新增、修改
    childType: {
      type: String,
      default: 'add'
    },
    // 获取数据源
    childDataSource: {
      type: Array,
      default: () => []
    },
    // 获取列表
    columns: {
      type: Array,
      default: () => []
    },
    // 获取调用弹框名称，注意 名称一定要对应
    modalRef: {
      type: String,
      default: ''
    },
    projectId: {
      type: String,
      default: ''
    },
    isScroll: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showable: false,
      count: 0,
      dataSource: this.childDataSource,
      deleteList: [],
      deleteMaterialTimeDetailList: []
    }
  },
  methods: {
    onCellChange (key, dataIndex, value) {
      const dataSource = [...this.dataSource]
      const target = dataSource.find(item => item.key === key)
      if (target) {
        target[dataIndex] = value
        this.dataSource = dataSource
      }
    },
    onDelete (record) {
      const key = record.key
      const id = record.id
      const dataSource = [...this.dataSource]
      this.dataSource = dataSource.filter(item => item.key !== key)
      const deleteList = [...this.deleteList]
      if (typeof (id) !== 'undefined' && id != null && id !== '') {
        dataSource.forEach(da => {
          if (da.id === id) {
            deleteList.push(da.id)
          }
        })
        this.dataSource = dataSource.filter(item => item.id !== id)
      }
      if (typeof (key) !== 'undefined' && key != null) {
        this.dataSource = dataSource.filter(item => item.key !== key)
      }
      this.deleteList = deleteList
    },
    editChild (record) {
      this.$refs[this.modalRef].edit(record, 'edit')
    },
    add () {
      this.$refs[this.modalRef].edit(null, 'add')
    },
    changeData (value) {
      const { count, dataSource } = this
      const newData = value
      newData.key = count
      this.dataSource = [...dataSource, newData]
      this.count = count + 1
    },
    editData (value) {
      const newData = value
      const dataSource = [...this.dataSource]
      const index = this.dataSource.filter(item => item.key === value.key).map(data => data.key)
      this.dataSource = dataSource.filter(item => item.key !== value.key)
      this.dataSource.splice(index, 0, newData)
    },
    // 提供给外部机械类的时间详细
    changeDelete (value) {
      this.deleteMaterialTimeDetailList = value
    }
  },
  watch: {
    dataSource (val) {
      this.dataSource = val
      // 向父组件更新
      this.$emit('changeFatherData', val)
    },
    // 监听父类传过来的值，并且进行key的赋值操作，如果key没有值，操作将找不到索引
    childDataSource (val) {
      val.forEach(da => {
        da.key = this.count
        this.count = this.count + 1
      })
      this.dataSource = val
    },
    childType (val) {
      this.childType = val
    },
    // 监听删除列表变化，传递给父类
    deleteList (val) {
      this.$emit('changeFatherDeleteList', val)
    },
    deleteMaterialTimeDetailList (val) {
      this.$emit('deleteMaterialTimeDetailList', val)
    }
  },
  mounted () {
    if (this.childType === 'show') {
      this.showable = true
    }
  }
}
</script>

<style scoped>

</style>
